import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/tableapi"

export type UserAdministration_CompanyType = {
  CardCode: string
  CardName: string
}

let columns: { [key in keyof UserAdministration_CompanyType]: SYSColumnDef } = {
  CardCode: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColCardCode" },
  },
  CardName: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColCardName" },
  },
}

export let tblUserAdministration_Company: SYSTableDef = {
  id: "SYSUserAdministration_Company",
  permission: "SYSCA",
  feature: "SYSUserAdministration",
  database: {
    dataIdField: "CardCode",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "useradministration/company",
  },

  options: {
    initial_sort: { field: "CardName", direction: "asc" },
    initial_paging: { page: 0, pageSize: 200 },
  },

  features: {
    add: true,
    delete: true,
    edit: true,
    filter: true,
  },
  columns,
}
